'use strict';

module.exports = Odigeo.Model.extend({
    defaults: {
        autocompleteResults: [],
        autocompleteSuggestions: [],
        autocompleteSuggestionsLimit: 5,
        searchKey: '',
        searchWord: '',
        searchCompletedFor: [],
        selectedLocation: null,
    },

    initialize: function(attributes, options) {
        this.departureOrArrival = options.departureOrArrival;
        this.showNearestLocations = options.showNearestLocations;
        this.on('change:searchWord', this.setSearchKey);
        this.on('change:autocompleteResults change:searchWord autocomplete', this.triggerAutocomplete);
        this.on('change:searchKey', this.fetch);
    },

    parse: function(response) {
        if (!Odigeo._.includes(this.get('searchCompletedFor'), this.get('searchKey'))) {
            this.get('searchCompletedFor').push(this.get('searchKey'));
        }
        return {'autocompleteResults': response};
    },

    url: function() {
        var showNearestLocations = this.showNearestLocations ? ';nearestLocations=true' : '';
        var searchData = JSON.parse(Odigeo.Session.get('searchParameters') || '{}');
        let product = 'FLIGHT';

        if (searchData.trainSearch) {
            product = 'TRAIN';
        }

        return Odigeo.Settings.property('geoServiceUrlFormatter')('autocomplete') +
            ';searchWord=' + encodeURIComponent(this.get('searchKey')) +
            ';departureOrArrival=' + this.departureOrArrival +
            ';addSearchByCountry=true' +
            ';addSearchByRegion=true' +
            showNearestLocations +
            ';product=' + product;
    },

    setSearchKey: function() {
        var searchWord = this.get('searchWord');
        var searchKey = Odigeo.Utils.replaceAccents(searchWord.substr(0, 3).toUpperCase());
        if (searchWord.length >= 3) {
            this.set('searchKey', searchKey);
        }
    },

    locationContains: function(location, searchWord) {
        var replacedSearchWord = Odigeo.Utils.replaceNonAlphaNumeric(searchWord, '', true);
        return Odigeo.Utils.replaceNonAlphaNumeric(location, '', true).indexOf(replacedSearchWord) >= 0 && replacedSearchWord.length;
    },

    formatLocation: function(loc) {
        var template = Odigeo._.partial(Odigeo._.template, _, Odigeo.Utils.getTmplSettings({variable: null}));
        var formatter = {
            AIRPORT: template('{{ (displayName || name) }}'),
            CITY: template('{{ (displayName || name) }}'),
            IATA_CODE: template(
                '{{ !Odigeo._.isEmpty(relatedLocations) ? displayName + " - " + relatedLocations[0].name : displayName + " - " + name }}'
            ),
        };
        var type;
        if (loc.relatedLocations.length > 1) {
            Odigeo._.each(loc.relatedLocations, function(rel) {
                type = rel.geoNodeType || rel.type;
                Odigeo._.extend(rel, {
                    text: Odigeo._.isFunction(formatter[type.toUpperCase()]) ? formatter[type.toUpperCase()](rel) : '',
                });
            });
        }
        if (!Odigeo._.has(loc, 'displayName') || Odigeo._.isEmpty(loc.displayName)) {
            Odigeo._.extend(loc, {
                displayName: loc.city,
            });
        }
        type = loc.geoNodeType || loc.type || 'CITY';

        return Odigeo._.extend(loc, {
            text: Odigeo._.isFunction(formatter[type.toUpperCase()]) ? formatter[type.toUpperCase()](loc) : '',
        });
    },

    filterLocations: function(searchWord) {
        var omitted = this.showNearestLocations ? ['type', 'geoNodeId', 'relatedLocations'] : ['type', 'geoNodeId'];
        return Odigeo._.filter(this.toJSON().autocompleteResults, function(location, index) {
            return Odigeo._.chain(location)
                .omit(omitted)
                .values()
                .even()
                .any(function(value) {
                    if (!Odigeo._.isString(value)) {
                        return false;
                    }
                    return this.locationContains(value.toLowerCase(), searchWord.toLowerCase());
                }, this)
                .value();
        }, this);
    },

    fillDisplayName: function(location) {
        if (!Odigeo._.isEmpty(location.relatedLocations)) {
            Odigeo._.each(location.relatedLocations, function(rel) {
                Odigeo._.extend(rel, {
                    displayName: rel.name,
                });
            });
        }
    },

    suggestedLocations: function(searchWord) {
        return Odigeo._.map(this.filterLocations(searchWord), function(location) {
            var values = [location.name];
            var match;

            if (location.type !== 'REGION' && Odigeo._.isArray(location.locationNames)) {
                values = values.concat(location.locationNames);
            }

            match = Odigeo._.find(values, function(name) {
                return name.toLowerCase().indexOf(searchWord) >= 0;
            });

            this.fillDisplayName(location);

            return Odigeo._.chain(location)
                .extend({
                    displayName: ((location.geoNodeType === 'CITY' && location.type === 'IATA_CODE') ?
                        location.city : location.name) || match,
                })
                .tap(Odigeo._.bind(this.formatLocation, this))
                .value();
        }, this);
    },

    triggerAutocomplete: function() {
        var autocompleteResults = this.get('autocompleteResults');
        var autocompleteSuggestionsLimit = this.get('autocompleteSuggestionsLimit');
        var searchWord = this.get('searchWord');
        var filteredResults;

        if (searchWord.length < 3) {
            this.trigger('clear:filtered');
            return;
        }

        Odigeo._.mixin({even: function(list) {
            if (Odigeo._.isObject(list)) {
                return Odigeo._.flatten(Odigeo._.map(Odigeo._.isArray(list) ? Odigeo._.flatten(list) : list, Odigeo._.even));
            } else {
                return list;
            }
        }});

        filteredResults = this.suggestedLocations(searchWord);

        if (this.showNearestLocations) {
            filteredResults = Odigeo._.uniq(filteredResults, function(e) {
                return Odigeo._.pluck(e.relatedLocations, 'geoNodeId').sort().toString();
            });
        }

        filteredResults = filteredResults.slice(0, autocompleteSuggestionsLimit);
        this.set('autocompleteSuggestions', filteredResults);
        if (Odigeo._.isArray(autocompleteResults) && Odigeo._.includes(this.get('searchCompletedFor'), this.get('searchKey'))) {
            this.trigger('autocompleted', filteredResults, searchWord);
        }
    },
});
